webpackJsonp([177849732307671],{

/***/ 485:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Norman Marigza","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/QstnBp2UMuCkec8mCUCEE/0b31c539999127f6f41965aa5c89c7f2/Norm.jpg"}},"content":{"content":"![MSA004M blog](//images.contentful.com/1o5ly3na7qu2/2RkJ30PD1SQcUeAaIQisGS/f1037e6b188a1e58fbc8fc204deb4b4d/MSA004M_blog.JPG)\n\n__Norman Marigza__\n- MSA Co-Founder\n- Astronomer, physicist, and STEM educator\n- National Coordinator of Astronomers Without Borders for the Philippines\n- Adviser, Philippine Union of Student Organizations for Astronomy\n- Team Leader, Guild for Astronomy Innovation and Advancement"}}},"pathContext":{"id":"c7fL4WyotwcYcUQGC4yioa6"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-norman-marigza-9b0096cc417b658b4275.js